(function () {
    'use strict';

    angular.module('thankview.odderExample', ['thankview.global'])
        .controller('OdderExampleController', ['$scope', '$rootScope', '$window', '$document', function ($scope, $rootScope, $window, $document) {
            const password = 'odder';
            $scope.currentTab = 0;

            $scope.init = function () {
                if ($window.location.search) {
                    const passParts = $window.location.search.split('?')[1].split('=');
                    if (passParts[0] === 'password') {
                        $scope.hasAccess = passParts[1] === password;
                    }
                }
            };

            $scope.changeTabs = function (index) {
                $scope.currentTab = index;
            };

            $scope.submitPassword = function () {
                $scope.hasAccess = $scope.password === password;

                if (!$scope.hasAccess) {
                    $rootScope.$broadcast('open-message', 'Incorrect password. Please try again.');
                }
            };

            $scope.downloadFile = function (name, file) {
                const link = $document[0].createElement('a');
                link.download = name;
                link.href = file;
                link.click();
            };

            $scope.shareFile = function () {
                $rootScope.$broadcast('open-message', 'Sharing is unavailable on the demo page.');
            };

            $scope.printFile = function () {
                $rootScope.$broadcast('open-message', 'Printing is unavailable on the demo page.');
            };

            $scope.orderFile = function () {
                $rootScope.$broadcast('open-message', 'Ordering is unavailable on the demo page.');
            };

            $scope.init();
        }]);
}());
